// The before-you-go card (redesign D, Oct 24; snippets/leave-offer.liquid). It opens once when someone looks like they
// are leaving: on a computer when the pointer leaves through the top of the window (towards the tabs, the address bar or
// the close button); on a phone, which has no pointer, after a quick flick back up the page once they have read down at
// least a screen. Never in the first 20 seconds of a visit's first page, never over the quick add, the cart drawer or a
// menu, at most once a week per visitor, and never again after a sign-up anywhere on the site. With something in the
// cart it shows the cart reminder (the gap to free shipping from /cart.js) instead of the sign-up. The sign-up is
// Shopify's customer form, so sending it reloads the page; the card then opens on its thank-you (or its error).
(() => {
  const card = document.getElementById('LeaveOffer');
  if (!card || window.leaveOffer) return;
  const scrim = card.previousElementSibling;
  const KEY = 'leave-offer';
  const WEEK = 7 * 24 * 3600 * 1000;
  const local = (k, v) => { try { return v === undefined ? localStorage.getItem(k) : localStorage.setItem(k, v); } catch { return null; } };
  const session = (k, v) => { try { return v === undefined ? sessionStorage.getItem(k) : sessionStorage.setItem(k, v); } catch { return null; } };
  const mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
  let shown = false, opener = null;

  function open(view, cart) {
    shown = true;
    show(view);
    if (view === 'cart' && cart) {
      const gap = 7500 - cart.total_price; // the store's free US shipping on $75+
      const ship = card.querySelector('[data-lo-ship]');
      ship.textContent = gap > 0 ? `You're $${(gap / 100).toFixed(2).replace(/\.00$/, '')} away from free US shipping.` : 'Your order ships free in the US.';
      ship.hidden = false;
    }
    opener = document.activeElement;
    scrim.hidden = false;
    card.hidden = false;
    void card.offsetHeight; // laid out closed, so the class change animates without waiting for a frame
    scrim.classList.add('is-open');
    card.classList.add('is-open');
    card.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey);
  }
  function show(view) {
    card.querySelectorAll('.lo__view').forEach((v) => { v.hidden = v.dataset.view !== view; });
    card.setAttribute('aria-labelledby', card.querySelector(`[data-view="${view}"] h2`)?.id || '');
  }
  function close() {
    card.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(() => { card.hidden = true; scrim.hidden = true; }, mqReduce.matches ? 160 : 200);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const items = [...card.querySelectorAll('button, a[href], input:not([type="hidden"])')].filter((el) => !el.closest('[hidden]'));
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  card.addEventListener('click', (e) => {
    if (e.target.closest('[data-lo-close]')) close();
    const to = e.target.closest('[data-lo-view]');
    if (to) { show(to.dataset.loView); card.querySelector('.lo__email')?.focus({ preventScroll: true }); }
  });
  scrim.addEventListener('click', close);
  card.querySelector('.lo__form')?.addEventListener('submit', () => session(`${KEY}-sent`, '1'));
  window.leaveOffer = { open, close }; // for checks in the console

  // Back from our own sign-up: the thank-you, or the form again with its error
  const posted = /[?&]customer_posted=true/.test(location.search);
  if (session(`${KEY}-sent`)) {
    session(`${KEY}-sent`, '');
    if (posted && card.querySelector('[data-lo-posted]')) { local(`${KEY}-done`, '1'); open('done'); return; }
    if (card.querySelector('[data-lo-error]')) { open('form'); return; }
  }
  if (posted) local(`${KEY}-done`, '1'); // a sign-up through any of the site's forms
  if (local(`${KEY}-done`) || Date.now() - (Number(local(`${KEY}-at`)) || 0) < WEEK) return;

  const t0 = Number(session(`${KEY}-t0`)) || Date.now();
  session(`${KEY}-t0`, String(t0));
  const pages = (Number(session(`${KEY}-pages`)) || 0) + 1;
  session(`${KEY}-pages`, String(pages));
  const ready = () => pages > 1 || Date.now() - t0 > 20000;
  const busy = () => document.documentElement.classList.contains('qp-lock') || document.body.classList.contains('overflow-hidden')
    || document.querySelector('cart-drawer.active, .qp.is-open, details[open] > .menu-drawer, details[open] > .search-modal');

  async function fire() {
    if (shown || !ready() || busy()) return;
    shown = true;
    detach();
    local(`${KEY}-at`, String(Date.now()));
    let cart = null;
    try { cart = await (await fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin' })).json(); } catch {}
    open(cart?.item_count ? 'cart' : 'form', cart);
  }

  // A computer: the pointer leaves through the top edge
  const onOut = (e) => { if (!e.relatedTarget && e.clientY <= 0) fire(); };
  // A phone: a flick back up of at least a third of the screen within 400 ms, after reading down at least a screen
  let marks = [];
  const onScroll = () => {
    const y = window.scrollY, t = performance.now();
    marks.push([y, t]);
    marks = marks.filter(([, mt]) => t - mt < 400);
    const peak = Math.max(...marks.map(([my]) => my));
    if (peak > window.innerHeight && peak - y > Math.max(240, window.innerHeight / 3)) fire();
  };
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const detach = () => { document.removeEventListener('mouseout', onOut); window.removeEventListener('scroll', onScroll); };
  if (fine) document.addEventListener('mouseout', onOut);
  else window.addEventListener('scroll', onScroll, { passive: true });
})();
